import React, { useState } from 'react'
import HospitalClaimDetails from '../HospitalClaimDetails/HospitalClaimDetails'
import FuneralClaimDetails from '../FuneralClaimDetails/FuneralClaimDetails'
import AccidentalClaimsDetails from '../AccidentalClaimsDetails/AccidentalClaimsDetails'
import LegalClaimDetails from '../LegalClaimDetails/LegalClaimDetails'
import RoadsideAssistanceDetails from '../RoadsideAssistanceDetails/RoadsideAssistanceDetails'
import Grid from "@material-ui/core/Grid";
import { SelectValidator, ValidatorForm } from 'react-material-ui-form-validator';
import { useStyle } from "./Style";
import MenuItem from '@mui/material/MenuItem';

export default function AdditionalDetails(props) {
  const classes = useStyle();
  const [claimType, setClaimType] = useState(props.claimState.type_of_claim || '');

  const handleClaimTypeChange = (event) => {
    const value = event.target.value;
    setClaimType(value);
    props.setAdditionalState("type_of_claim", value);
  };

  if(props.hasMediCashIllnessBenefit || props.hasMediCashAccidentBenefit){
    return <HospitalClaimDetails {...props} />
  }
  
  if(props.hasAccidentalDeathBenefits){
    return (
      <>
        <Grid container spacing={2}>
          <Grid item xs={12} sm={12} md={12}>
            <div style={{ marginBottom: '15px', fontWeight: 'bold', color: '#333', fontSize: '18px' }}>
              Claim Type Selection
            </div>
          </Grid>
        </Grid>
        
        <ValidatorForm onSubmit={() => {}}>
          <Grid container spacing={2} style={{ marginBottom: '20px' }} className={classes.selectpolicyWrapper}>
            <Grid item xs={12} md={6} sm={6}>
              <SelectValidator
                labelId="select-claim-type"
                id="select-claim-type"
                value={claimType}
                name="claimType"
                type="text"
                label="Select Type of Claim"
                onChange={handleClaimTypeChange}
                variant="outlined"
                validators={['required']}
                errorMessages={['Please select the type of claim']}
                style={{ width: "100%" }}
                sx={{
                  fontFamily: "Open Sans",
                  fontStyle: "normal",
                  fontWeight: 300,
                  fontSize: "12px",
                  lineHeight: "16px",
                  letterSpacing: "0.005em",
                  color: "#000000",
                }}
              >
                {["Accidental Disability", "Accidental Death"].map((type, index) => (
                  <MenuItem
                    key={index}
                    sx={{
                      fontFamily: "Open Sans",
                      fontStyle: "normal",
                      fontWeight: 300,
                      fontSize: "12px",
                      lineHeight: "16px",
                      letterSpacing: "0.005em",
                      color: "#000000",
                    }}
                    value={type}
                  >
                    {type}
                  </MenuItem>
                ))}
              </SelectValidator>
            </Grid>
          </Grid>
        </ValidatorForm>

        {claimType === "Accidental Disability" && (
          <AccidentalClaimsDetails {...props} />
        )}
        
        {claimType === "Accidental Death" && (
          <FuneralClaimDetails {...props} />
        )}
      </>
    );
  }
  
  if(props.hasLegalCoverBenefit || props.hasBDFandPrisonsBenefit){
    return <LegalClaimDetails {...props} />
  }
  if(props.hasRoadsideAssistanceBenefit){
    return <RoadsideAssistanceDetails {...props} />
  }

  

  
}
